module.exports = __webpack_public_path__ + "static/img/title_icon1.1d7df73b.jpg";